<template>
  <v-dialog v-model="isVisible" max-width="500">
    <v-card>
      <v-card-title class="headline accent" primary-title>
        {{ title || "Error" }}
      </v-card-title>
      <v-card-text class="alert-message py-4">
        <template v-if="message">
          <div v-for="(msg, idx) in message.split('\n')" :key="idx" class="my-1 min-height">
            {{ msg }}
          </div>
        </template>
        <template v-else>
          An error has occured.
        </template>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer />
        <v-btn color="primary" @click="$emit('dismissed')">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['message', 'title', 'isVisible'],
};
</script>

<style scoped>
  .alert-message {
    font-size: 17px;
  }
  .min-height {
    min-height: 1em;
  }
</style>
